import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployees } from "../../redux/employeeSlice";
import { addFine, updateFine } from "../../redux/fineSlice";

const FineModal = ({ isOpen, onClose, onSubmit, fine }) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: fine || { employeeId: "", fineReason: "", fineAmount: "", fineDate: "" },
  });
  const dispatch = useDispatch();
  const { employees, status: employeeStatus } = useSelector((state) => state.employees);

  useEffect(() => {
    if (employeeStatus === "idle") {
      dispatch(fetchEmployees());
    }
  }, [employeeStatus, dispatch]);

  useEffect(() => {
    if (fine) {
      setValue("employeeId", fine.employeeId || "");
      setValue("fineReason", fine.fineReason || "");
      setValue("fineAmount", fine.fineAmount || "");
      setValue("fineDate", fine.fineDate ? fine.fineDate.split("T")[0] : "");
    }
  }, [fine, setValue]);

  const handleFormSubmit = (data) => {
    // Convert employeeId to number
    const fineData = { ...data, employeeId: Number(data.employeeId) };
    if (fine?.id) {
      dispatch(updateFine({ id: fine.id, updatedData: fineData }));
    } else {
      dispatch(addFine(fineData));
    }
    reset();
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
        <h2 className="text-lg font-semibold mb-4">{fine ? "Edit Fine" : "Add Fine"}</h2>
        <form onSubmit={handleSubmit(handleFormSubmit)}>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">Employee</label>
            <select
              {...register("employeeId", { required: "Employee is required" })}
              className="w-full border rounded px-3 py-2 text-sm"
            >
              <option value="">Select Employee</option>
              {employees.map((employee) => (
                <option key={employee.id} value={employee.id}>
                  {employee.firstName} {employee.lastName} ({employee.cnic})
                </option>
              ))}
            </select>
            {errors.employeeId && (
              <span className="text-red-500 text-sm">{errors.employeeId.message}</span>
            )}
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">Fine Reason</label>
            <input
              type="text"
              {...register("fineReason", { required: "Fine reason is required" })}
              className="w-full border rounded px-3 py-2 text-sm"
              placeholder="Reason for Fine"
            />
            {errors.fineReason && (
              <span className="text-red-500 text-sm">{errors.fineReason.message}</span>
            )}
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">Fine Amount</label>
            <input
              type="number"
              step="0.01"
              {...register("fineAmount", { required: "Fine amount is required", min: 0 })}
              className="w-full border rounded px-3 py-2 text-sm"
              placeholder="Fine Amount"
            />
            {errors.fineAmount && (
              <span className="text-red-500 text-sm">{errors.fineAmount.message}</span>
            )}
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">Date</label>
            <input
              type="date"
              {...register("fineDate", { required: "Date is required" })}
              className="w-full border rounded px-3 py-2 text-sm"
            />
            {errors.fineDate && <span className="text-red-500 text-sm">{errors.fineDate.message}</span>}
          </div>
          <div className="flex justify-end space-x-2">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-500 text-white px-4 py-2 rounded"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-[#241763] text-white px-4 py-2 rounded"
            >
              {fine ? "Update Fine" : "Add Fine"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FineModal;